export default __webpack_public_path__ + "static/media/img_area_kako.d17eac51.svg";